import React from "react";

import Logo from "../../../assets/images/icali_logo.jpg";
import { useCreateIcali2Context } from "../create/provider/createIcali2.provider";
import { useCreateNewsIcali2Context } from "../create/news/provider/createNewsIcali2.provider";
import { useCreateUsedIcali2Context } from "../create/used/provider/createUsedIcali2.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const { setFlow, setStep, step } = useCreateIcali2Context();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsIcali2Context();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedIcali2Context();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex px-32">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="-ml-7 w-24 lg:ml-0 lg:w-52">
            <img
              alt="icali_acinco_logo"
              src={Logo}
              className="img-fluid w-full"
            />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
